import React, {useState, useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BasicText from '../DebtPaymentComponents/basicText';
import BasicImage from '../DebtPaymentComponents/basicImage';
import {errorEnum} from '../DebtPaymentComponents/debtPaymentEnum';
import Action from '../DebtPaymentComponents/action';
import Config from '../../../../Config';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import {numWithStarRTL} from '../../../../utilities/StringHelpers/StringHelpers';
import {CSSTransition} from 'react-transition-group';

import '../debtPayment.scss';
import '../debtPaymentAnimations.scss';

const GeneralError = (props) => {
  const [mount, setMount] = useState(false);

  let mainImg = require('../images/icons-error.svg');

  let title = 'שירות זה אינו זמין';
  let dial = require('../images/icons-call-phone.svg');
  let actionText = props.isMobile ? 'חיוג ' + numWithStarRTL(Config.businessCallNumber) + 'לאחראי שירות' : 'לפנייה לנציג שירות יש לחייג למספר ';

  //let bodyText = props.isMobile ? 'אנחנו לא יכולים להשלים כרגע את\n התהליך. כדאי לנסות שוב עוד כמה\n רגעים או להסדיר את התשלום דרך\n המוקד הפיננסי שלנו' :
  const actionOnClick = (e) => {
    gaEvent(
      gaParams.DEBT_PAYMENT_CLICK_GENERALERROR.category,
      gaParams.DEBT_PAYMENT_CLICK_GENERALERROR.eventType,
      gaParams.DEBT_PAYMENT_CLICK_GENERALERROR.eventParams,
    );
    window.open('tel:' + e);
  };

  useEffect(() => {
    if (props.currentStep === errorEnum.GENERAL) {
      setMount(true);
      gaEvent(
        gaParams.DEBT_PAYMENT_SHOW_GENERALERROR.category,
        gaParams.DEBT_PAYMENT_SHOW_GENERALERROR.eventType,
        gaParams.DEBT_PAYMENT_SHOW_GENERALERROR.eventParams,
      );
    } else {
      setMount(false);
    }
  }, [props.currentStep]);

  return (
    <CSSTransition key={14} in={mount} timeout={250} classNames='stepwrapper' mountOnEnter unmountOnExit>
      <Container fluid className='debtpayment-step'>
        <Row className='debtpayment-container justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='תשלום חוב' classname='debtpayment-title' />
          </Col>
        </Row>
        <Row className='debtpayment-step-title justify-content-md-center'>
          <Col md='auto'>
            <BasicText text={'זה לא היה צפוי...'} classname={'main-text-extra-bold'} />
          </Col>
        </Row>
        <Row className='debtpayment-step-subtitle justify-content-md-center'>
          <Col md='auto'>
            <BasicText
              text={'אנחנו לא יכולים להשלים כרגע את התהליך.\nכדאי לנסות שוב עוד כמה רגעים או להסדיר את התשלום דרך המוקד הפיננסי שלנו'}
            />
          </Col>
        </Row>
        {props.isMobile ? (
          <Action
            text={'לשיחה עם המוקד הפיננסי ' + numWithStarRTL(window.Config.financeCallNumber1)}
            img={dial}
            onclick={actionOnClick}
            fnParams={window.Config.financeCallNumber1}
            bold
          />
        ) : (
          <Row className='justify-content-md-center'>
            <Col>
              <BasicText text={'לשיחה עם המוקד הפיננסי ' + numWithStarRTL(window.Config.financeCallNumber1)} bold color='businessPurple' />
            </Col>
          </Row>
        )}
        <Row className='justify-content-md-center main-img'>
          <Col md='auto'>
            <BasicImage src={mainImg} />
          </Col>
        </Row>
        <Row className='justify-content-md-center footer-btn'>
          <Col md='auto'>
            <BtnSubmit isBusiness formid='' text='סיום' onclick={props.onclick} />
          </Col>
        </Row>
      </Container>
    </CSSTransition>
  );
};

export default GeneralError;
